import { Grid } from '@mui/material';
import { LearningTypeListLoading } from './skeleton';
import {
  LearningTypeCard,
  type LearningTypeCardProps,
} from '@/components/shared/learning-type-card';

export type LearningTypeListProps = {
  data: LearningTypeCardProps[];
  isLoading?: boolean;
};

export const LearningTypeList = ({
  data,
  isLoading = false,
}: LearningTypeListProps) => {
  if (isLoading) {
    return <LearningTypeListLoading />;
  }

  return (
    <Grid container spacing={2}>
      {data?.map((courseType, idx) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
          <LearningTypeCard {...courseType} />
        </Grid>
      ))}
    </Grid>
  );
};
